import { useQuery } from "@tanstack/react-query";

import Workflow from "../../../components/workflow/Workflow";
import { getFolder } from "../../../services/projects";
import { isNil } from "../../../utils/fp";
import PunttDashboardLoader from "../../index/loader";
import { ticketsRoute } from "../route";

export default function FolderWorkflow() {
  // We can get the folderId from any page, but it has to exist in the search
  // params and is totally optional.
  const { folderId, aiPersonas } = ticketsRoute.useSearch();
  const folderQuery = useQuery({
    queryKey: ["folders", folderId],
    queryFn: () => getFolder(folderId!),
    enabled: !isNil(folderId),
  });

  if (folderQuery.isPending) {
    return <PunttDashboardLoader />;
  }

  return (
    <Workflow
      // @ts-expect-error TS2322: casting to null doesn't do anything, either.
      folder={folderQuery.data}
      folderId={folderId}
      personas={aiPersonas?.map(
        (p) => p.toLowerCase() as Lowercase<(typeof aiPersonas)[number]>,
      )}
    />
  );
}
